<script lang="ts" setup>
import { SpaceBetweenSwiper } from '~/enums'
import { usePartnerProvider } from '~/composables/common/use-partner-providers'
import { useSwiper } from '~/composables/common/use-swiper'
const { modules, SwiperSlide, Swiper } = useSwiper()
const { logoPartners } = usePartnerProvider()

const { isMobile } = useDevice()
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean

const swiperOptions = {
  slidesPerView: isMobile ? 5.5 : 9.5,
  slidesPerGroup: 1,
  lazy: true,
  spaceBetween: isMobile
    ? SpaceBetweenSwiper.Small
    : SpaceBetweenSwiper.XxlLarger,
  autoplay: $isLighthouseBot
    ? false
    : {
        delay: 1,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        reverseDirection: true
      },
  speed: 3000,
  loop: !$isLighthouseBot,
  breakpoints: {
    1200: {
      spaceBetween: SpaceBetweenSwiper.Medium,
      slidesPerView: 5.5,
    },
    1400: {
      spaceBetween: SpaceBetweenSwiper.Large,
      slidesPerView: 6.5,
    },
    1600: {
      spaceBetween: SpaceBetweenSwiper.xlLarger,
      slidesPerView: 8.5,
    },
    1800: {
      spaceBetween: SpaceBetweenSwiper.XxlLarger,
      slidesPerView: 9.5,
    },
  },
}
const currentLogoPartners = computed(() => {
  if ($isLighthouseBot) {
    return logoPartners?.slice(0, 6)
  }
  return logoPartners
})
</script>

<template>
  <div class="providers">
    <div class="providers__title">
      <img
        src="/images/home/provider/ic-provider-title.webp"
        alt="provider-title"
        class="providers__title-img"
        width="124"
        height="24"
        loading="lazy"
      />
    </div>
    <div class="providers__list">
      <Swiper
        v-if="logoPartners?.length"
        :modules="modules"
        v-bind="swiperOptions"
      >
        <SwiperSlide
          v-for="item in currentLogoPartners"
          :key="item.title"
          class="providers__item"
        >
          <a
            v-if="item.link"
            :href="item.link"
            class="providers__link"
            target="_blank"
            rel="nofollow"
          >
            <img
              :src="item.logoMb"
              :alt="item.title"
              class="providers__logo"
              :title="item.title"
              width="100%"
              height="100%"
              loading="lazy"
            />
          </a>
          <img
            v-else
            :src="item.logoMb"
            :alt="item.title"
            class="providers__logo"
            :title="item.title"
            width="100%"
            height="100%"
            loading="lazy"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/mobile/home/providers.scss';
</style>
